import { render, staticRenderFns } from "./SeafaringPracticeUpsertForm.vue?vue&type=template&id=5288b4f1"
import script from "./SeafaringPracticeUpsertForm.vue?vue&type=script&lang=ts"
export * from "./SeafaringPracticeUpsertForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports